import { Space } from 'antd';

export const InputGroup = Space.Compact;
